class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    console.log("Custom Filter");
  }

  connectedCallback() {
    this.filterInputs = this.querySelectorAll("input, button");
    this.handleClick = this.handleClick.bind(this);

    this.minInput = this.querySelector("#price-min");
    this.maxInput = this.querySelector("#price-max");
    this.rangeMin = this.querySelector("#range-min");
    this.rangeMax = this.querySelector("#range-max");

    // Sync slider + inputs for instant UI feedback
    this.rangeMin?.addEventListener("input", () => {
      if (parseInt(this.rangeMin.value) > parseInt(this.rangeMax.value)) {
        this.rangeMin.value = this.rangeMax.value;
      }
      this.minInput.value = this.rangeMin.value;
    });

    this.rangeMax?.addEventListener("input", () => {
      if (parseInt(this.rangeMax.value) < parseInt(this.rangeMin.value)) {
        this.rangeMax.value = this.rangeMin.value;
      }
      this.maxInput.value = this.rangeMax.value;
    });

    this.minInput?.addEventListener("input", () => {
      if (parseInt(this.minInput.value) > parseInt(this.maxInput.value)) {
        this.minInput.value = this.maxInput.value;
      }
      this.rangeMin.value = this.minInput.value;
    });

    this.maxInput?.addEventListener("input", () => {
      if (parseInt(this.maxInput.value) < parseInt(this.minInput.value)) {
        this.maxInput.value = this.minInput.value;
      }
      this.rangeMax.value = this.maxInput.value;
    });

    // Attach main event listeners
    this.filterInputs.forEach((input) => {
      input.addEventListener("change", this.handleClick);
      input.addEventListener("click", this.handleClick);
    });
  }

  applyPriceFilter(min, max) {
    const url = new URL(window.location.href);

    if (min == 0 && max >= 99999) {
      // Remove price filter → ALL
      url.searchParams.delete("filter.v.price.gte");
      url.searchParams.delete("filter.v.price.lte");
    } else {
      url.searchParams.set("filter.v.price.gte", min);
      url.searchParams.set("filter.v.price.lte", max);
    }

    window.location.replace(url.toString());
  }

  handleClick(event) {
    const input = event.currentTarget;

    // Checkbox filters (existing behavior)
    if (input.dataset.type === "checkbox") {
      const url = new URL(
        input.checked ? input.dataset.addUrl : input.dataset.removeUrl,
        window.location.origin
      );
      window.location.replace(url);
      return;
    }

    // Price RADIO filter (existing behavior)
    if (input.dataset.type === "price") {
      const url = new URL(input.dataset.addUrl, window.location.origin);
      window.location.replace(url);
      return;
    }

    // PRICE PRESET BUTTONS
    if (input.dataset.type === "price-preset") {
      const preset = input.dataset.preset;

      if (preset === "all") {
        this.applyPriceFilter(0, 99999);
        return;
      }
      if (preset === "0-540") {
        this.applyPriceFilter(0, 540);
        return;
      }
      if (preset === "540-1080") {
        this.applyPriceFilter(540, 1080);
        return;
      }
    }

    // PRICE INPUTS or SLIDERS
    if (
      input.dataset.type === "price-min" ||
      input.dataset.type === "price-max"
    ) {
      const min = parseInt(this.minInput.value);
      const max = parseInt(this.maxInput.value);
      this.applyPriceFilter(min, max);
      return;
    }
  }
}

customElements.define("collection-filter", CollectionFilters);
